import ApiClient from "./apiClient";
import { getListParams, QueriesApi } from "./apiTypes";

const operationService = {
  getList:(queries:QueriesApi, client?:any) => ApiClient.get('operations', {
    params:{
      ...getListParams(queries),
      ordering:queries.ordering || '-created_at',
      active_client:client
    }
  }),
  getOperationById:(id:string) => ApiClient.get(`operations/${id}`),
  retryOperationStart:(operationId:string) => ApiClient.post(`operations/${operationId}/retry`),
  abortOperation:(operationId:string) => ApiClient.post(`operations/${operationId}/abort_operation`)
}

export default operationService
